import React from "react";
import { useForm } from "react-hook-form";
import { withTranslation } from "react-i18next";
import SimpleBar from "simplebar-react";

const EntryForm = ({ t }) => {
  const { register, handleSubmit, reset, watch } = useForm({
    defaultValues: {
      itemCode: "ITEM00100",
      itemName: "",
      source: "ગુજરાતમાથી",
      commission: 0,
      userCharge: "No",
      category: "1",
    },
  });

  const onSubmit = (data) => {
    console.log("Form Data:", data);
    alert(JSON.stringify(data, null, 2));
  };

  return (
    <div className="page-content">
      <div className="p-4">
        <div className="container p-4  border rounded bg-light">
          <h2 className="mb-3 text-center">જલારામ વેજીટેબલ કું - ૨</h2>

          <form onSubmit={handleSubmit(onSubmit)} className="space-y-3">
          <div class="row">
            <div class="col-10">
              <div className="row">
                <div className="col-9">
                    <div class="row mb-3">
                      <label for="example-search-input" class="col-sm-2 col-form-label">આઈટમનો કોડ :</label>
                      <div class="col-sm-10">
                        <input
                          type="text"
                          {...register("itemCode")}
                          className="form-control disabled"
                          disabled
                        />
                      </div>
                    </div>
                    <div class="row mb-3">
                      <label for="example-search-input" class="col-sm-2 col-form-label">આઈટમનું પુરુ નામ :</label>
                      <div class="col-sm-10">
                        <input
                          type="text"
                          {...register("itemName", { required: true })}
                          className="form-control"
                          placeholder="સ્ટા"
                        />
                      </div>
                    </div>
                    <div class="row mb-3">
                      <label for="example-email-input" class="col-sm-2 col-form-label">આઈટમનો કોડ :</label>
                      <div class="col-sm-10">
                        <div class="col-sm-10">
                          <input
                            type="text"
                            {...register("itemCode")}
                            className="form-control"
                            readOnly
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <label for="example-email-input" class="col-sm-2 col-form-label">આઈટમ બહારથી આવે છે ?</label>
                        <div class="col-sm-10">
                          <label>
                            <input type="radio" value="ગુજરાતમાથી" {...register("source")} />
                            ગુજરાતમાથી
                          </label>
                          <label className="ms-3">
                            <input type="radio" value="ગુજરાત બહારથી" {...register("source")} />
                            ગુજરાત બહારથી
                          </label>
                        </div>
                    </div>
                    <div class="row mb-3">
                      <label for="example-email-input" class="col-sm-2 col-form-label">કમિશન % :</label>
                        <div class="col-sm-10">
                          <input
                          type="number" {...register("commission")} className="form-control"min="0"/>
                        </div>
                    </div>
                    <div class="row mb-3">
                      <label for="example-email-input" class="col-sm-2 col-form-label">યુઝર ચાર્જ લાગુ પડે છે ?</label>
                        <div class="col-sm-10">
                          <label>
                              <input type="radio" value="Yes" {...register("userCharge")} /> Yes
                            </label>
                            <label className="ms-3">
                              <input type="radio" value="No" {...register("userCharge")} /> No
                            </label>
                        </div>
                    </div>
                    <div class="row mb-3">
                      <label for="example-email-input" class="col-sm-2 col-form-label">આઈટમની કેટેગરી :</label>
                        <div class="col-sm-10">                          
                          <select {...register("category")} className="form-select">
                            <option value="1">૧</option>
                            <option value="2">૨</option>
                          </select>
                        </div>
                    </div>
                </div>
                <div className="col-3">
                  <div class="btn-group-vertical w-100">
                    <button type="button" class="btn w-100 btn-success mb-2">{t("ProductsDetail")}</button>
                    <button type="button" class="btn w-100 btn-success mb-2">{t("Save")}</button>
                    <button type="button" class="btn w-100 btn-info mb-2">{t("Discount")}</button>
                    <button type="button" class="btn w-100 btn-danger mb-2">{t("Print")}</button>
                  </div>
                </div>
              </div>

            </div>
            <div class="col-2">
              <div class="btn-group-vertical w-100">
                <button type="button" class="btn w-100 btn-success mb-2">{t("Save")}</button>
                <button type="button" class="btn w-100 btn-info mb-2">{t("Update")}</button>
                <button type="button" class="btn w-100 btn-danger mb-2">{t("Delete")}</button>
                <button type="button" class="btn w-100 btn-info mb-2 disabled">{t("Cancel")}</button>
                <button type="button" class="btn w-100 btn-success mb-2 disabled">{t("Draft")}</button>
                <button type="button" class="btn w-100 btn-info mb-2">{t("Exit")}</button>
              </div>
            </div>
          </div>
      </form>
      
          {/* Item List Table */}
          <SimpleBar style={{ height: "400px" }}>
            <div data-simplebar className="h-100">
              <div className="mt-4">
                <h5>આઈટમ લિસ્ટ</h5>
                <table className="table table-bordered bg-white">
                  <thead>
                    <tr>
                      <th>કોડ નં</th>
                      <th>આઈટમનું નામ</th>
                      <th>કેટેગરી</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>ITEM001</td>
                      <td>વટાણા દેશી</td>
                      <td>૨</td>
                    </tr>
                    <tr>
                      <td>ITEM002</td>
                      <td>જુના કાંદા</td>
                      <td>૧</td>
                    </tr>
                    <tr>
                      <td>ITEM003</td>
                      <td>ભીંડો </td>
                      <td>૧</td>
                    </tr>
                    <tr>
                      <td>ITEM004</td>
                      <td>ટામેટા </td>
                      <td>૧</td>
                    </tr>
                    <tr>
                      <td>ITEM005</td>
                      <td>લસણ </td>
                      <td>૧</td>
                    </tr>
                    <tr>
                      <td>ITEM001</td>
                      <td>વટાણા દેશી</td>
                      <td>૨</td>
                    </tr>
                    <tr>
                      <td>ITEM002</td>
                      <td>જુના કાંદા</td>
                      <td>૧</td>
                    </tr>
                    <tr>
                      <td>ITEM003</td>
                      <td>ભીંડો </td>
                      <td>૧</td>
                    </tr>
                    <tr>
                      <td>ITEM004</td>
                      <td>ટામેટા </td>
                      <td>૧</td>
                    </tr>
                    <tr>
                      <td>ITEM005</td>
                      <td>લસણ </td>
                      <td>૧</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </SimpleBar>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(EntryForm);
